export const referralsGet = (searchField, sortColumn, sortDirection, limit) => {
    return {
        type: 'REFERRALS_GET',
        payload: { searchField, sortColumn, sortDirection, limit }
    }
}

export const referralsGetSuccess = (items, totalItems) => {
    return {
        type: 'REFERRALS_GET_SUCCESS',
        payload: { items, totalItems }
    }
}

export const referralsGetError = (error) => {
    return {
        type: 'REFERRALS_GET_ERROR',
        payload: error
    }
}

export const referralsSetSearchField = (searchField, sortColumn, sortDirection, limit) => {
    return {
        type: 'REFERRALS_SET_SEARCH_FIELD',
        payload: searchField
    }
}

export const referralsSetSorting = (selectedSortOption, sortDirection) => {
    return {
        type: 'REFERRALS_SET_SORTING',
        payload: { selectedSortOption, sortDirection }
    }
}

export const referralsLoadMore = (searchField, sortColumn, sortDirection, limit) => {
    return {
        type: 'REFERRALS_LOAD_MORE',
        payload: { searchField, sortColumn, sortDirection, limit }
    }
}

export const referralsLoadMoreSuccess = (items, totalItems) => {
    return {
        type: 'REFERRALS_LOAD_MORE_SUCCESS',
        payload: { items, totalItems }
    }
}

export const referralsLoadMoreError = (error) => {
    return {
        type: 'REFERRALS_LOAD_MORE_ERROR',
        payload: error
    }
}

export const referralsDeleteItem = (itemId) => {
    return {
        type: 'REFERRALS_DELETE_ITEM',
        payload: itemId
    }
}

export const referralsDeleteItemSuccess = (itemId) => {
    return {
        type: 'REFERRALS_DELETE_ITEM_SUCCESS',
        payload: itemId
    }
}

export const referralsDeleteItemError = (error) => {
    return {
        type: 'REFERRALS_DELETE_ITEM_ERROR',
        payload: error
    }
}

export const referralsSetDeleted = () => {
    return {
        type: 'REFERRALS_SET_DELETED'
    }
}

export const referralsUnsetDeleted = () => {
    return {
        type: 'REFERRALS_UNSET_DELETED'
    }
}

export const referralsSetMessage = (message) => {
    return {
        type: 'REFERRALS_SET_MESSAGE',
        payload: message
    }
}

export const referralsUnsetMessage = () => {
    return {
        type: 'REFERRALS_UNSET_MESSAGE'
    }
}

export const referralsUnsetError = () => {
    return {
        type: 'REFERRALS_UNSET_ERROR'
    }
}

export const referralsGetDetails = (itemId) => {
    return {
        type: 'REFERRALS_GET_DETAILS',
        payload: itemId
    }
}

export const referralsGetDetailsSuccess = (item) => {
    return {
        type: 'REFERRALS_GET_DETAILS_SUCCESS',
        payload: item
    }
}

export const referralsGetDetailsError = (error) => {
    return {
        type: 'REFERRALS_GET_DETAILS_ERROR',
        payload: error
    }
}

export const referralsSetInsertField = (field, value) => {
    return {
        type: 'REFERRALS_SET_INSERT_FIELD',
        payload: { field, value }
    }
}

export const referralsInsert = (item) => {
    return {
        type: 'REFERRALS_INSERT',
        payload: item
    }
}

export const referralsInsertSuccess = (item) => {
    return {
        type: 'REFERRALS_INSERT_SUCCESS',
        payload: item
    }
}

export const referralsInsertError = (error) => {
    return {
        type: 'REFERRALS_INSERT_ERROR',
        payload: error
    }
}

export const referralsUnsetInserted = () => {
    return {
        type: 'REFERRALS_UNSET_INSERTED'
    }
}

export const referralsSetCustomer = (customer) => {
    return {
        type: 'REFERRALS_SET_CUSTOMER',
        payload: customer
    }
}

export const referralsLoadUpdate = (id) => {
    return {
        type: 'REFERRALS_LOAD_UPDATE',
        payload: id
    }
}

export const referralsLoadUpdateSuccess = (item) => {
    return {
        type: 'REFERRALS_LOAD_UPDATE_SUCCESS',
        payload: item
    }
}

export const referralsLoadUpdateError = (error) => {
    return {
        type: 'REFERRALS_LOAD_UPDATE_ERROR',
        payload: error
    }
}

export const referralsSetUpdateField = (field, value) => {
    return {
        type: 'REFERRALS_SET_UPDATE_FIELD',
        payload: { field, value }
    }
}

export const referralsUpdate = (id, item) => {
    return {
        type: 'REFERRALS_UPDATE',
        payload: {id, item}
    }
}

export const referralsUpdateSuccess = (item) => {
    return {
        type: 'REFERRALS_UPDATE_SUCCESS',
        payload: item
    }
}

export const referralsUpdateError = (error) => {
    return {
        type: 'REFERRALS_UPDATE_ERROR',
        payload: error
    }
}

export const referralsUnsetUpdated = () => {
    return {
        type: 'REFERRALS_UNSET_UPDATED'
    }
}

export const referralsStatsLoad = () => ({
    type: 'REFERRALS_STATS_LOAD'
})

export const referralsStatsLoadSuccess = (stats) => ({
    type: 'REFERRALS_STATS_LOAD_SUCCESS',
    payload: stats
})

export const referralsStatsLoadError = (error) => ({
    type: 'REFERRALS_STATS_LOAD_ERROR',
    payload: error
})

export const referralsUsePoints = (id, productName, points ) => ({
    type: 'REFERRALS_USE_POINTS',
    payload: { id, points, productName }
})

export const referralsUsePointsSuccess = (item) => ({
    type: 'REFERRALS_USE_POINTS_SUCCESS',
    payload: item
})

export const referralsUsePointsError = (error) => ({
    type: 'REFERRALS_USE_POINTS_ERROR',
    payload: error
})